@if (loading) {
  <div style="width: 100%;text-align: center;">
    <div style="display:flex;justify-content: center;align-items: center"><mat-spinner></mat-spinner></div><br>
  </div>
}
<div class="btn-div">
</div>
<table mat-table [dataSource]="data" class="mat-elevation-z8" matSort>
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
    <td mat-cell *matCellDef="let element"> {{element.respondent_id}} </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum </th>
    <td mat-cell *matCellDef="let element"> {{element.request_at | date : "d.M.YYYY"}} </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef> Anonymizovat </th>
    <td mat-cell *matCellDef="let element"> <button mat-icon-button (click)="anonymize(element.respondent_id)"><mat-icon>person_remove</mat-icon></button></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
